/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "search",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#666666"
            },
            "st1": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "none",
                "stroke": "#666666",
                "strokeWidth": "21",
                "strokeLinecap": "round",
                "strokeLinejoin": "round",
                "strokeMiterlimit": "10"
            },
            "search": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "223.5",
            "height": "226.5"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 223.5 226.5", className: "search", width: this.props.width, height: this.props.height, style: this.props.search },
            _react2["default"].createElement("path", { className: "st0", d: "M186 152.8l31.6 31.6c8.7 8.7 7.7 23.9-2.2 33.9-10 10-25.1 11-33.8 2.3L150 189c-8.7-8.7-7.7-23.9 2.2-33.9 10-10 25.1-11 33.8-2.3z", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st1", d: "M10.5 82.8c0-39.9 32.3-72.3 72.1-72.3s72.1 32.4 72.1 72.3-32.3 72.3-72.1 72.3-72.1-32.4-72.1-72.3z", style: this.props.st1 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/search.js